import wndata from './wn_data.json'
import Vue from 'vue'
import store from "../store";
let notification = new Vue();
export default {
  //share job link to apps
    shareJob(data) {
      var vm = this;
      console.log("sharejob data : ", data)
      console.log("jobid : ", wndata.selectedJobURL+data.jobAliasId)
      console.log("title : ", data.jobTitle)
      if (!navigator.share) return;

      navigator.share({
        url: wndata.selectedJobURL+data.jobAliasId,
        title: data.jobTitle,
        text: data.jobTitle+" | To see more information about this job ! please click on the link."
      })
      .then(() => { console.log("Shared job!!!!!"); })
      .catch((error) => { vm.$toast.info("No longer support this functionality in this device/browser") });
    },
    //copy link
    copyJobLink(data){
      var vm =this;
      var copiedlink = wndata.selectedJobURL+data.jobAliasId
      navigator.clipboard.writeText(copiedlink);
      notification.$toast.success(wndata.copylinkMessage)
    },
    //copy referral link
    copyReferralCode(data){
      var copiedlink = data
      navigator.clipboard.writeText(copiedlink);
      notification.$toast.success("Copied to clipboard")
    },
    //smooth scrolling to the top
    scorlltop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    //update user experinece while add/update/delete work experience
    updateLoginUserWorkExperience(workExperience) {
      var totalMonths = 0;
      if(workExperience.length > 0){
        for(var i =0; i < workExperience.length; i++) {
          let startDate = new Date(workExperience[i].startDate)
          let endDate;
          var res = 0;
          if(workExperience[i].currentWorkingFlag !== 'Y'){
            endDate = new Date(workExperience[i].endDate)
          }else{
            endDate = new Date()
          }
          res = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())
          totalMonths += res; 
        }
        store.state.totalWorkExperience = totalMonths;
        console.log("total months : ", totalMonths)
        function getPlural(number, word) {
          return number === 1 && word.one || word.other;
        }
        var months = { one: 'month', other: 'months' },
            years = { one: 'year', other: 'years' },
            m = totalMonths % 12,
            y = Math.floor(totalMonths / 12);
        var finalRes = (y + ' ' + getPlural(y, years)) +' and '+(m + ' ' + getPlural(m, months))
      }
    },
    checkJobLevelToApply(seniority) {
      console.log("seniority level in commonutils : ", seniority)
      var positions = [
        {level : "Internship", monthFrom : 0, monthTo : 0},
        {level : "Entry Level", monthFrom : 0, monthTo : 24},
        {level : "Associate", monthFrom : 25, monthTo : 48},
        {level : "Mid-Senior Level", monthFrom : 49, monthTo : 120},
        {level : "Director", monthFrom : 121, monthTo : null},
        {level : "Executive", monthFrom : 181, monthTo : null},
      ]
      // for internship , entry level
      // need to check profile information except workexperience
      // display error messages on modal based on these conditions
      // contact information is mandotory
      if(seniority) {
        for(var i =0; i < positions.length; i++) {
          if(seniority == positions[i].level) {
            let startMonthFrom = positions[i].monthFrom;
            let endMonthTo = positions[i].monthTo;
            console.log("matched with seniority", positions[i].level, startMonthFrom, endMonthTo, store.state.totalWorkExperience)
            if(seniority !== 'Director' && seniority !== 'Executive'){
              console.log("into if section")
              if(store.state.addedContactInfo && store.state.profileStrengthPercentage >= 50 && startMonthFrom < store.state.totalWorkExperience && store.state.totalWorkExperience <= endMonthTo || store.state.totalWorkExperience > endMonthTo){
                return true
              }else{
                return false;
              }
            }else{
              console.log("into else section")
              if(store.state.addedContactInfo && store.state.profileStrengthPercentage >= 50 && store.state.totalWorkExperience >= startMonthFrom){
                return true
              }else{
                return false;
              }
            }
          }
        }
      }
    },
    // handle pincode
    setPincode(pincode){
      if(pincode) {
        if(String(pincode).length == 4){
          return '0'+pincode;
        }else{
          return pincode
        }
      }else{
        return null;
      }
    },

    convertLocalDateToUTCDate:function(date) {
        date = date+' ' + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds()
        date = new Date(date);
        var convDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
        return convDate;
      },

    conversionbyNag:function(date) {
      var doo = new Date(date);
      //var timezoneoffset = -120; // gmt+2, == -120 (minutes)
      //console.log("NEW COnversion: "+ new Date( doo.getTime() - doo.getTimezoneOffset() * -60000 ) )
      return new Date( doo.getTime() - doo.getTimezoneOffset() * -60000 );
      
    },
    strToDate:function(strDate) {
      try{
       //-1 became javascript has months from 0-11
        return new Date(strDate.substring(0, 4), strDate.substring(5,7)-1,strDate.substring(8,10),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion"+strDate)
      }
    },
    formatDateMoment:function(date) {
      try{
        return new Date(date.year(), date.month(),date.date(),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion formatDate"+date)
      }
    },
    formatDateJS:function(date) {
      try{
        return new Date(date.getFullYear(), date.getMonth(),date.getDate(),12,0,0,0);
      }catch(e){
          console.log("Error in Date in conversion formatDate"+date)
      }
    }
}
